module.exports = __webpack_public_path__ + "img/translate-logo.bcb73288.png";